import { IonContent, IonInput, IonPage, IonText, IonIcon, IonSpinner } from "@ionic/react"
import moment from "moment"
import { useEffect, useState, useMemo } from "react"
import { useHistory } from "react-router"
import { Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import service from "../../Service/service"
import Head from "../Header"
import Select from 'react-select';
import Sidebar from "../Sidebar"
import swal from 'sweetalert';
import DatePicker from "react-date-picker";
import { searchOutline, chevronDownOutline } from "ionicons/icons";

const TimelogDetailReport: React.FC = () => {
    const history = useHistory();
    const [token] = useState(localStorage.getItem("SignupEmpId"));
    useEffect(() => {
        if (token === null) {
            history.push("/login");
        } else {
        }
    }, [token, history]);
    const [id] = useState(localStorage.getItem("SignupEmpId"))
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [projectId, setProjectId] = useState("");
    const [monthName, setMonthName] = useState("")
    const [month, setMonth] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [project, setProject] = useState([]);

    //----------------Project Autocomplete------------------//

    const [selectedOption, setSelectedOption] = useState(null);
    const [inputValue, setInputValue] = useState('');
    const [isFocused, setIsFocused] = useState(false);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    const [statusId, setStatusId] = useState('')
    const [projectStatusId, setProjectStatusId] = useState("")
    const [statusList, setStatusList] = useState([]);
    const [filterText, setFilterText] = useState("");
    const [data, setData] = useState([]);
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showTable, setShowTable] = useState(false);
    const [employeeid, setemployeeid] = useState([])
    const [selectedRows, setSelectedRows] = useState([]);
    const handleRowSelected = (state: any) => {
        const selectedIds = state.selectedRows.map((row: any) => row.id);
        console.log(selectedIds);
        setSelectedRows(selectedIds)
    };

    const isButtonDisabled = selectedRows.length === 0;
    const dataArray = Array.isArray(data) ? data : [data];
    dataArray.forEach((item: any, index: any) => {
        item.serial = index + 1;
    });
    const handleStateChange = (selectedOption: any) => {
        setSelectedOption(selectedOption);
    };

    const handleInputChange = (inputValue: any) => {
        setInputValue(inputValue);
    };

    const handleMenuOpen = () => {
        setMenuIsOpen(true);
    };

    const handleMenuClose = () => {
        setMenuIsOpen(false);
    };

    const handleFocus = () => {
        setIsFocused(true);
    };

    const handleBlur = () => {
        setIsFocused(false);
    };
    const Placeholder = () => {
        if (inputValue === '' && !selectedOption && !isFocused) {
            return <span style={{ color: "black" }}>Select Project </span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };
    const back = () => {
        history.goBack();
    }
    const DropdownIndicator: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };

    const options = project.map((state: any) => ({
        value: state.id,
        label: state.projectName,
    }));

    const handleprojectUnitChange = (selectedOption: any) => {
        setProjectId(selectedOption.value);
    };
    // const hanldeStatusType = (e: any) => {
    //     setProjectStatusId(e.target.value)
    //     LoadProject();
    //     service.GetallProject(id, e.target.value)
    //         .then((response) => {
    //             console.log(response, "project")
    //             if (response.data.status === "200") {
    //                 setProject(response.data.Data);
    //             }
    //             else {
    //                 setProject([]);
    //             }
    //         })
    // }



    //.................Project Status Autocomplete........................//

    const [selectedOption9, setSelectedOption9] = useState(null);
    const [inputValue9, setInputValue9] = useState('');
    const [isFocused9, setIsFocused9] = useState(false);
    const [menuIsOpen9, setMenuIsOpen9] = useState(false);

    const handleStateChange9 = (selectedOption9: any) => {
        setSelectedOption9(selectedOption9);
    };

    const handleInputChange9 = (inputValue9: any) => {
        setInputValue9(inputValue9);
    };

    const handleMenuOpen9 = () => {
        setMenuIsOpen9(true);
    };

    const handleMenuClose9 = () => {
        setMenuIsOpen9(false);
    };

    const handleFocus9 = () => {
        setIsFocused9(true);
    };

    const handleBlur9 = () => {
        setIsFocused9(false);
    };

    const Placeholder9 = () => {
        if (inputValue9 === '' && !selectedOption9 && !isFocused9) {
            return <span style={{ color: "black" }}>Open</span>;
        } else {
            return <span style={{ color: "black" }}>Type to Search Here...</span>;
        }
    };

    const DropdownIndicator9: any = ({ innerProps, selectProps }: any) => {
        const [isClicked, setIsClicked] = useState(false);

        useEffect(() => {
            if (isClicked && !selectProps.menuIsOpen9) {
                setIsClicked(false);
            }
        }, [selectProps.menuIsOpen9]);

        let icon;
        if (isClicked || selectProps.menuIsOpen) {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={searchOutline} />;
        } else {
            icon = <IonIcon style={{ color: "black", fontSize: '15px', marginTop: "5px" }} icon={chevronDownOutline} />;
        }

        const handleIconClick = () => {
            setIsClicked(true);
        };

        return (
            <div {...innerProps}>
                <div onClick={handleIconClick}>{icon}</div>
            </div>
        );
    };
    const options9 = statusList.map((state: any) => ({
        value: state.id,
        label: state.status,
    }));

    const hanldeStatusTypes = (selectedOption9: any) => {
        setProjectStatusId(selectedOption9.value);
        // LoadProject();
    }
    //-------------Getall Project Dropdown---------------//

    useEffect(() => {
        LoadProject();
        GetStatusList();
    }, []);

    const LoadProject = () => {
        service.GetallProject(id, projectStatusId)
            .then((response) => {
                console.log(response, "project")
                if (response.data.status === "200") {
                    setProject(response.data.Data);
                }
                else {
                    setProject([]);
                }
            })
    }
    // ----------------------Get status list ---------------------

    const GetStatusList = () => {
        service.GetPrjClsStatuslist()
            .then((response) => {
                console.log(response);
                if (response.status === 200) {
                    setStatusList(response.data);
                }
                else {
                    setStatusList([])
                }
            })
    }

    useEffect(() => {
        LoadProject();
    }, [projectStatusId]);

   const Search = () => {
    if (!projectId) {
        swal("", "Please select Project", "info");
        return;
    }
    if (!month) {
        swal("", "Please select Month&Year", "info");
        return;
    }
    
    service.Employeeassign(projectId)
        .then((response) => {
            if (response.data.status === "200") {
                setData(response.data.Data);
                setShowTable(true);
                const employeeIds = response.data.Data.map((employee:any) => employee.id);
                setemployeeid(employeeIds);
            } else if (response.data.status === "400") {
                swal("Error", response.data.message, "error");
            }
        })
        .catch((error) => {
            console.log(error);
        });
};

    //------------------Month(First and Last date)--------------------//

    const getMonth = (e: any) => {
        console.log(e, "dsvm")

        if (e) {
            setMonth(e)

            const formattedDate = moment(e).format("YYYY-MM");
            let date: any = formattedDate.split('-');

            let year = date[0];
            let month = date[1];
            let startDate = moment([year, month - 1])
            let endDate = moment(startDate).endOf('month');

            var dates = [];
            let weeks = [];

            var per_week = [];
            var difference = endDate.diff(startDate, 'days');

            per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
            let index = 0;
            let last_week = false;

            while (startDate.add(1, 'days').diff(endDate) < 0) {
                if (startDate.day() != 0) {
                    per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
                }
                else {
                    if ((startDate.clone().add(7, 'days').month() == (month - 1))) {
                        weeks.push(per_week)
                        per_week = []
                        per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"))
                    }
                    else if (Math.abs(index - difference) > 0) {
                        if (!last_week) {
                            weeks.push(per_week);
                            per_week = [];
                        }
                        last_week = true;
                        per_week.push(moment(startDate.toDate()).format("YYYY-MM-DD"));
                    }
                }
                index += 1;
                if ((last_week == true && Math.abs(index - difference) == 0) ||
                    (Math.abs(index - difference) == 0 && per_week.length == 1)) {
                    weeks.push(per_week)
                }
                dates.push(startDate.clone().toDate());
            }

            let week1 = weeks.join()
            let days = (week1).split(',');
            let fDate: any;
            let tDate: any;
            if (days.length <= 1) {
                fDate = days[0]
                tDate = days.pop()
            }
            else if (days.length > 1) {
                fDate = days[0];
                tDate = days.pop();
            }

            setFromDate(fDate);
            setToDate(tDate);

            console.log(fDate, "km");
            console.log(tDate, "lm");

            const d = new Date();
            d.setMonth(month - 1);
            const monthName1 = d.toLocaleString("default", { month: "long" });
            console.log(monthName1, "month");
            setMonthName(monthName1);
        }
    }
    const Downloadpdf = () => {
        service.EmployeeEffortPdf(projectId, fromDate, toDate, selectedRows)
            .then((response) => {
                if (response.status === '200') {
                    console.log('PDF generated and downloaded successfully.');
                } else {

                    //sweetAlert("", 'No Data Found', 'error' || 'No DATA FOUND!');
                }
            })
            .catch((error) => {

                swal('An unexpected error occurred: ' + error.message);
            });
    };
    const DownloadExcel = () => {
        service.EmployeeExcel(projectId, fromDate, toDate, selectedRows)
            .then((response) => {
                if (response.status === '200') {
                    console.log('Excel generated and downloaded successfully.');
                } else {

                    //sweetAlert("", 'No Data Found', 'error' || 'No DATA FOUND!');
                }
            })
            .catch((error) => {

                swal('An unexpected error occurred: ' + error.message);
            });
    };

    const columns: any = [
        {
            name: "S.No",
            selector: (itm: any, i: any) => itm.serial,
            sortable: true,
            width: "100px",
        },
        {
            name: "Business Unit",
            selector: (itm: any) => itm.businessUnit.businessUnitName,
            sortable: true,
        },
        {
            name: "Department Unit",
            selector: (itm: any) => itm.masterDepartment.departmentName,
            sortable: true,
        },
        {
            name: "Employee Name",
            sortable: true,
            width: "250px",
            cell: (itm: any) => (
                <>
                    <div>{itm.name}{" ("}{itm.employeeCode}{")"}</div>
                </>
            )
        },

        {
            name: "Status",
            sortable: true,
            cell: (itm: any) => (
                <>
                    <IonText className={itm.statusFlag === true ? "color_approve" : "color_deny"}>
                        {itm.statusFlag === true ? "Active" : "Inactive"}
                    </IonText>
                </>
            )
        }


    ];

    const customStyles = {
        headRow: {
            style: {
            },
        },
        headCells: {
            style: {
                fontWeight: "bold",
                fontSize: "15px",
                justifyContent: "center"
            },
        },
        cells: {
            style: {
                fontSize: "16px",
                justifyContent: "center"
            }
        }
    };


    const datatable = Array.isArray(data)
        ? data.filter((item: any) =>
            JSON.stringify(item).toLowerCase().includes(filterText.toLowerCase())
        )
        : [];


    const paginationComponentOptions = {
        selectAllRowsItem: true,
        selectAllRowsItemText: "ALL"
    };
    const subHeaderComponent = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText("");
            }

        };

        return (
            <div style={{ display: "flex" }}>
                <div style={{ display: "flex" }}>
                    <div className="form-group form-focus row">
                        <IonInput type="text" className="form-control floating" onIonChange={(e: any) => setFilterText(e.target.value)}
                            value={filterText} placeholder="Search" />
                        <label className="focus-label">Search</label>
                    </div>
                    <button type="button" style={{ backgroundColor: "orange", width: "45px", marginTop: "4px", height: "40px", position: 'absolute' }} onClick={handleClear}>X</button>
                </div>
            </div>
        )

    }, [filterText, resetPaginationToggle]);

    //--------------------Pdf generate Api-------------//

    const Export = () => {
        setIsLoading(true);
        setTimeout(() => {
            if (month === null) {
                setIsLoading(false);
                swal("", "Please Select Month & Year", "info");
            } else if (projectId === "") {
                setIsLoading(false);
                swal("", "Please Select Project", "info");
            } else {
                service.GetTimeSheetReport(fromDate, toDate, projectId, monthName)
                    .then((response) => {
                        console.log(response, "Report");
                    })
                    .catch((error) => {
                        swal(error);
                    })
                    .finally(() => {
                        setIsLoading(false);
                    });
            }
        }, 1500);
    };

    return (
        <IonPage>
            <Head />
            <Sidebar />
            <IonContent>
                <div className="page-wrapper">
                    <div className="page-header">
                        <div className="content container-fluid">
                            <div className="row align-items-center">
                                <div className="col">
                                    <h3 className="page-title" style={{ fontWeight: "bold" }}>
                                        <i className="fa fa-arrow-left" onClick={back} style={{ color: "black", cursor: "pointer", marginRight: "5px" }} />
                                        Timelog Detail Report</h3>
                                </div>
                            </div>
                            {isLoading && (
                                <div
                                    style={{
                                        position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.8)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 10500
                                    }}
                                >
                                    <div>
                                        <IonSpinner style={{
                                            width: "40px",
                                            height: "40px",
                                            color: "#ff8a53"
                                        }} name="lines" />
                                    </div>
                                </div>
                            )}
                            <div className="row filter-row" style={{ marginTop: "3%" }}>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Project Status </label>
                                        <Select
                                            options={options9}
                                            value={options9.find((option: any) => option.value === projectStatusId) || null}
                                            onChange={hanldeStatusTypes}
                                            onInputChange={handleInputChange9}
                                            onMenuOpen={handleMenuOpen9}
                                            onMenuClose={handleMenuClose9}
                                            onFocus={handleFocus9}
                                            onBlur={handleBlur9}
                                            menuIsOpen={menuIsOpen9}
                                            isSearchable
                                            // disabled={isEdit === true ? false : true}
                                            placeholder={<Placeholder9 />}
                                            components={{
                                                DropdownIndicator: DropdownIndicator9,
                                            }}
                                            className="custom-select5"
                                        />

                                    </div>

                                </div>


                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}>Project <span className="text-danger">*</span></label>
                                        <div>
                                            <Select
                                                options={options}
                                                value={options.find((option) => option.value === projectId) || null}
                                                onChange={handleprojectUnitChange}
                                                onInputChange={handleInputChange}
                                                onMenuOpen={handleMenuOpen}
                                                onMenuClose={handleMenuClose}
                                                onFocus={handleFocus}
                                                onBlur={handleBlur}
                                                menuIsOpen={menuIsOpen}
                                                isSearchable
                                                placeholder={<Placeholder />}
                                                components={{
                                                    DropdownIndicator: DropdownIndicator,
                                                }}
                                                className="custom-select2"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-3">
                                    <div className="form-group">
                                        <label style={{ fontWeight: "bold" }}> Month & Year <span className="text-danger">*</span></label>
                                        <div>
                                            {/* <IonInput type="month" onIonChange={(e: any) => getMonth(e)} className="form-control datetimepicker" /> */}
                                            <DatePicker clearIcon={null} maxDetail="year" format="MM/yyyy" value={month} className="form-control" onChange={getMonth} />
                                        </div>
                                    </div>
                                </div>
                                <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => Search()} className="btn btn-success btn-block w-100"> Search </a>
                                </div>
                                <div style={{ marginTop: "5px", display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                                    <div className="col-sm-6 col-md-3">
                                        <a
                                            className={`btn btn-success btn-block w-100 ${isButtonDisabled ? "disabled" : ""}`}
                                            onClick={DownloadExcel}
                                            style={isButtonDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                        >
                                            Download Excel
                                        </a>
                                    </div>
                                    <div className="col-sm-6 col-md-3">
                                        <a
                                            className={`btn btn-success btn-block w-100 ${isButtonDisabled ? "disabled" : ""}`}
                                            onClick={Downloadpdf}
                                            style={isButtonDisabled ? { pointerEvents: "none", opacity: 0.5 } : {}}
                                        >
                                            Download PDF
                                        </a>
                                    </div>
                                </div>


                                {showTable && (
                                    <div className="table-responsive" style={{ marginTop: "20px" }}>
                                        <DataTable
                                            columns={columns}
                                            data={datatable}
                                            pagination
                                            paginationPerPage={10}
                                            paginationComponentOptions={paginationComponentOptions}
                                            paginationRowsPerPageOptions={[10, 20, 30]}
                                            subHeader
                                            subHeaderComponent={subHeaderComponent}
                                            selectableRows
                                            onSelectedRowsChange={handleRowSelected}
                                            customStyles={customStyles}
                                        />
                                    </div>
                                )}
                                {/* <div className="col-sm-6 col-md-3" style={{ display: "flex", alignSelf: "center", justifySelf: "center" }}>
                                    <a onClick={() => {
                                        // Empresources();
                                       LoadProject();
                                    }} className="btn btn-orange btn-block w-100"> SEARCH </a>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </IonContent>
        </IonPage>
    )
}

export default TimelogDetailReport